import { BodyText } from '@unmind/design-system-components-web';
import { Link } from 'react-router-dom';
import { styled } from 'styles';

export const HeadingWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: top;
`;

export const ArrowWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
`;

export const StyledLink = styled(Link)`
  display: flex;
  width: 100%;
  height: inherit;
  align-items: center;
  justify-content: center;
  background-color: inherit;
  text-decoration: none;
  &:active {
    opacity: 0.5;
  }
`;

export const ManagersCategorySectionContainer = styled.section``;

export const StyledText = styled(BodyText).attrs(({ theme }) => ({
  color: theme.colors.text.primary,
  sizes: [theme.typography.fontSizes.fontSize16],
  weight: theme.typography.fontWeights.medium,
}))``;
